document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (!target) return;

    const headerOffset = 200; // Adjust this if there's a fixed header
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    const totalScrollDistance = Math.abs(window.pageYOffset - offsetPosition);
    const duration = Math.max(44, totalScrollDistance / 2); // Adjust for slower or faster scrolling
    const start = window.pageYOffset;
    let startTime = null;

    function smoothScroll(currentTime) {
      if (!startTime) startTime = currentTime;

      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      const easeInOutQuad = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      const scrollTo = start + easeInOutQuad * (offsetPosition - start);

      window.scrollTo(0, scrollTo);

      if (progress < 1) {
        requestAnimationFrame(smoothScroll);
      }
    }

    requestAnimationFrame(smoothScroll);
  });
});